import { AxiosRequestConfig } from 'axios';
import { config } from '../../config';
import { AxiosInstance } from '../axios-instance';

export class CommonAxiosService {
    URL = config.whatsapp_notification_url;
    axiosPostCall = async (urlEndPoint: string, data?: any, config?: AxiosRequestConfig) => {
        return await AxiosInstance.post(this.URL + '' + urlEndPoint, data, config)
            .then(res => {
                return res.data;
            }).catch(err => {
                throw new Error(err.message);
            })
    }
}